import imageUrlBuilder from "@sanity/image-url"

const builder = imageUrlBuilder({
  projectId: "0lx88bm4",
  dataset: "production",
})

export function imageUrlFor(source) {
  return builder.image(source)
}
